import React from 'react';

const PlayIcon = ({ color = 'white', style }) => (
  <svg
    width='20'
    height='20'
    viewBox='0 0 20 20'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
    style={style}
  >
    <path
      d='M4.09091 3.62683C4.09091 2.74395 4.09091 2.30252 4.27499 2.05918C4.43536 1.84719 4.68048 1.71601 4.94582 1.70016C5.2504 1.68198 5.6177 1.92684 6.35229 2.41657L15.9119 8.78964C16.5189 9.1943 16.8224 9.39663 16.9281 9.65165C17.0206 9.87461 17.0206 10.1252 16.9281 10.3481C16.8224 10.6032 16.5189 10.8055 15.9119 11.2101L6.35229 17.5832C5.6177 18.0729 5.2504 18.3178 4.94582 18.2996C4.68048 18.2838 4.43536 18.1526 4.27499 17.9406C4.09091 17.6973 4.09091 17.2558 4.09091 16.373V3.62683Z'
      stroke={color}
      strokeWidth='2'
      strokeLinecap='round'
      strokeLinejoin='round'
    />
  </svg>
);

export default PlayIcon;
